import { Box, Switch, Typography } from '@material-ui/core';
import React from 'react';
import { useCampfireLazyQuery } from '../../../../../global/network/useCampfireLazyQuery';
import { useSnackbar } from '../../../../../global/config/useSnackbar';
import { useCampfireFetch } from '../../../../../global/network/useCampfireFetch';
import { useApiUrl } from '../../../../../global/config/useApiUrl';
import { GET_CONFIG_ITEM } from './config-item.gql';
import { GetConfigItem } from './__generated__/GetConfigItem';
import { AllowUnavailabilityAndLeave } from './AllowUnavailabilityAndLeave';

export function PreventVolunteerAvailabilitySubmission() {
  const [queryPreventVolunteerAvailabilitySubmission] = useCampfireLazyQuery<GetConfigItem, { key: string }>(
    GET_CONFIG_ITEM
  );
  const [preventVolunteerAvailabilitySubmission, setPreventVolunteerAvailabilitySubmission] = React.useState<
    boolean | undefined
  >();
  const { setSnackbar } = useSnackbar();

  React.useEffect(() => {
    queryPreventVolunteerAvailabilitySubmission({
      variables: { key: 'prevent-volunteer-availability-submission' },
    }).then((response) =>
      setPreventVolunteerAvailabilitySubmission(
        response.data?.vm.configItem?.defaultValue || response.data?.vm.configItem?.configItemValue?.flagValue
      )
    );
  }, []);

  const savePreventVolunteerAvailabilitySubmission = useCampfireFetch({ defer: true });

  const apiUrl = useApiUrl();
  const onSave = () => {
    savePreventVolunteerAvailabilitySubmission
      .run({
        url: `${apiUrl}/vm/admin-console/config`,
        method: 'post',
        data: {
          type: 'prevent-volunteer-availability-submission',
          value: !preventVolunteerAvailabilitySubmission,
        },
      })
      .then(() => {
        setSnackbar({
          open: true,
          message: 'Successfully updated',
          variant: 'success',
        });
      });
    setPreventVolunteerAvailabilitySubmission(!preventVolunteerAvailabilitySubmission);
  };

  return (
    <Box mt={2}>
      <Box display='flex' alignItems={'center'}>
        <Switch
          checked={Boolean(preventVolunteerAvailabilitySubmission)}
          onChange={onSave}
          color='primary'
          inputProps={{ 'aria-label': 'prevent volunteer availability submission' }}
        />
        <Box ml={1}>
          <Typography
            style={{
              fontWeight: 500,
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            Prevent Availability Submission
          </Typography>
          <Typography variant={'body2'} style={{ fontSize: '13px', color: '#808080' }}>
            {
              'Hide the availability centre and stop users submitting, updating, or withdrawing their own availability. Activity Leaders, Program Managers, and Admins can still manage volunteer availability. Activities with an open roster are not affected.'
            }
          </Typography>
        </Box>
      </Box>
      <AllowUnavailabilityAndLeave preventAvailabilityEnabled={Boolean(preventVolunteerAvailabilitySubmission)} />
    </Box>
  );
}
